function view (path) {
  return () => import(/* webpackChunkName: '' */ '@/views/provider/' + path).then(m => m.default || m) // eslint-disable-line prefer-template
}

const RProvider = [
  {
    path: '/provider/dashboard',
    component: view('Dashboard'),
    name: 'provider.dashboard',
    authorizedRole: 'provider'
  }
]

const RProviderAccounts = [
  {
    path: '/provider/accounts/organizations',
    component: view('accounts/Organizations'),
    name: 'provider.accounts.organizations',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Organizations',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/accounts/organization/:organization?',
    component: view('accounts/organization-manager/Base'),
    name: 'provider.accounts.organization-management',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Organization',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/accounts/card-holders',
    component: view('accounts/CardHolders'),
    name: 'provider.accounts.card-holders',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Users',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/accounts/users',
    component: view('accounts/Users'),
    name: 'provider.accounts.users',
    meta: {
      breadcrumb: [
        {
          text: 'Home'
        },
        {
          text: 'Accounts'
        },
        {
          text: 'Users',
          active: true
        }
      ]
    }
  }
]

const RProviderServices = [
  {
    path: '/provider/services/packages',
    component: view('services/Packages'),
    name: 'provider.services.packages',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Services'
        },
        {
          text: 'Packages',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/services/diagnostics',
    component: view('services/Diagnostics'),
    name: 'provider.services.diagnostics',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Services'
        },
        {
          text: 'Diagnostics',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/services/package/:packaged?',
    component: view('services/package-manager/Base'),
    name: 'provider.services.package-management',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Services'
        },
        {
          text: 'Package Management',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/services/cards',
    component: view('services/Cards'),
    name: 'provider.services.cards',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Services'
        },
        {
          text: 'Cards',
          active: true
        }
      ]
    }
  }
]

const RProviderLocations = [
  {
    path: '/provider/locations/regions',
    component: view('locations/Regions'),
    name: 'provider.locations.regions',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Locations'
        },
        {
          text: 'Regions',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/locations/provinces',
    component: view('locations/Provinces'),
    name: 'provider.locations.provinces',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Locations'
        },
        {
          text: 'Provinces',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/locations/municipalities',
    component: view('locations/Municipalities'),
    name: 'provider.locations.municipalities',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Locations'
        },
        {
          text: 'Municipalities',
          active: true
        }
      ]
    }
  },
  {
    path: '/provider/locations/barangays',
    component: view('locations/Barangays'),
    name: 'provider.locations.barangays',
    meta: {
      breadcrumb: [
        {
          text: 'Provider'
        },
        {
          text: 'Locations'
        },
        {
          text: 'Barangays',
          active: true
        }
      ]
    }
  }
]

export default RProvider.concat(
  RProviderAccounts,
  RProviderServices,
  RProviderLocations
)
